/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
// @ts-nocheck
import parsersForVersion from './parsers';
export function validateVersionConfig(version) {
    if (!version) {
        throw new Error('version is required');
    }
    const cleanVersion = (version !== null && version !== void 0 ? version : '').replace(/[^0-9a-zA-Z._-]/, '');
    if (cleanVersion !== version || !version) {
        throw new Error('invalid version supplied - version is required and uses semver syntax');
    }
    parsersForVersion(version); // will throw for invalid version
}
